import { Grid, styled } from "@mui/material";
import BuildingFormTableHeader from "./BuildingFormTableHeader";
import BuildingFormTableSubHeader from "./BuildingFormTableSubHeader";
import BuildingUnitList from "./building-table-units/BuildingUnitList";
import {
  UnitsProvider,
  useUnitsContext
} from "@rf/property/module/components/property-form/septions/property-steps/buildings-step/context/UnitsContext";
import { useBuildingDetail } from "../../context/BuildingDetailContext";
import MxButton2 from "@rf-l1/buttons/MxButton2";
import { memo } from "react";
import { useBuildingOpen } from "@rf/property/module/components/property-form/store/slices/BuildingTools";

interface IBuildingProps {}
const BuildingForm = (props: IBuildingProps) => {
  const { indexBuilding } = useBuildingDetail();
  return (
    <UnitsProvider buildingIndex={indexBuilding}>
      <ContentBuilding container>
        <IndexBuilding id={`building-${indexBuilding + 1}-index`}>
          {indexBuilding + 1}
        </IndexBuilding>
        <BuildingFormTableHeader />
        <BuildingFormTableSubHeader />
        <BuildingUnitList />
      </ContentBuilding>
      <Grid container justifyContent="center" alignItems="center">
        <ToggleExpanderUnitList />
      </Grid>
    </UnitsProvider>
  );
};

export default BuildingForm;

const ToggleExpanderUnitList = memo(() => {
  const { buildingOpen, onSetBuildingOpen } = useBuildingOpen();
  const { indexBuilding } = useBuildingDetail();
  const { fields } = useUnitsContext();

  return (
    <MxButton2
      variant="outlined"
      borderWidth={1}
      borderColor="primary.main"
      onClick={() =>
        onSetBuildingOpen(buildingOpen === indexBuilding ? null : indexBuilding)
      }
      testId="toggle-expander-unit-list-button"
    >
      {buildingOpen !== indexBuilding ? "Desplegar" : "Ocultar"} las unidades{" "}
      {fields.length}
    </MxButton2>
  );
});

const ContentBuilding = styled(Grid)(({ theme }) => ({
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: 12,
  position: "relative"
}));

const IndexBuilding = styled("span")(({ theme }) => ({
  color: "white",
  backgroundColor: theme.palette.primary.main,
  borderTopLeftRadius: 5,
  borderBottomLeftRadius: 0,
  borderTopRightRadius: 5,
  borderBottomRightRadius: 0,
  position: "absolute",
  top: -20,
  left: 10,
  width: "auto",
  minWidth: 40,
  height: 20,
  padding: 15,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "12px",
  fontWeight: "bold"
}));
